import { Component, OnDestroy, OnInit } from '@angular/core';
import { ManagerDashboardService } from '../../services/manager-dashboard.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LoggingService } from '../../services/logging.service';
import { Password } from '../../models/password';
import { TenantRouterService } from '../../services/tenant-router.service';

@Component({
  selector: 'app-update-password',
  standalone: false,
  templateUrl: './update-password.component.html',
  styleUrl: './update-password.component.scss'
})
export class UpdatePasswordComponent implements OnInit, OnDestroy {

  passwordForm !: FormGroup;
  passwordSubscription: Subscription = new Subscription();
  userId !: number;
  userRole !: string;
  message !: string;
  errorMessage : boolean = false;

  constructor(private managerDashboardService : ManagerDashboardService, private fb: FormBuilder, 
              private router : Router, private loggingService : LoggingService,
              private tenantRouter: TenantRouterService) {}

  ngOnInit() : void {
    this.buildChangePasswordForm();
    this.loggingService.logDebug("Getting the userId from session storage");
    const userid = sessionStorage.getItem('user_id');
    if(userid) {
      this.userId = parseInt(userid, 10);
    }
    this.loggingService.logDebug("Getting the userrole from session storage");
    const userrole = sessionStorage.getItem('user_role');
    if(userrole) {
      this.userRole = userrole;
    }
  }

  buildChangePasswordForm() {
    this.passwordForm = this.fb.group({
      existingPassword : ['', Validators.required],
      newPassword : ['',[ Validators.required,Validators.minLength(8),Validators.maxLength(64), Validators.pattern(/^(?=.*[0-9!@#$%^&*])[A-Za-z0-9!@#$%^&*]+$/)]]
    });
  }

  private isPasswordValid(password: string): boolean {
    const hasLetter = /[A-Za-z]/.test(password);
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasNumberOrSpecial = /[0-9!@#$%^&*]/.test(password);

    return hasLetter && hasNumberOrSpecial && hasUppercase && hasLowercase;
  }

  get newPasswordErrors(): string {
    const control = this.passwordForm.get('newPassword');

    if (control?.hasError('required')) {
      return 'New password is required';
    }
    if (control?.hasError('minlength')) {
      return 'Password must be at least 8 characters long';
    }
    if (control?.hasError('maxlength')) {
      return 'Password cannot exceed 64 characters';
    }
    if (control?.hasError('pattern')) {
      return 'Password must include at least one number or special character ';
    }
    return '';
  }
  


  changePassword() {

    if (!this.passwordForm.valid || !this.isPasswordValid(this.passwordForm.value.newPassword)) {
      this.errorMessage = true;
      this.message = "Password must include at least one uppercase character";
    
      return;
    }
    const password : Password = this.passwordForm.value;
    password.userID = this.userId;
    this.passwordSubscription = this.managerDashboardService.updatePassword(password).subscribe((response) => {
      alert('Password Updated Successfully');
      if(this.userRole === "manager") {
        this.tenantRouter.navigate('manager-dashboard');
      }
      else if(this.userRole === "user") {
        this.tenantRouter.navigate('user-dashboard');

      }
      else if(this.userRole === "hr") {
        this.tenantRouter.navigate('hr-dashboard');
      }      
      },
      (error) => {
        this.errorMessage = true;
        this.message = error.message;
      });
  }

  ngOnDestroy(): void {
    this.passwordSubscription.unsubscribe();
  }

}
